// extracted by mini-css-extract-plugin
module.exports = {"container":"MCOYE","time":"_2ALMt","title":"_2pnAt","chevron":"_2qZzQ"};